import { jsx as _jsx } from "react/jsx-runtime";
import { Box } from "@gemini/core";
import { Tag } from "@gemini/ui";
export const testId = "cdp-sections-units-unit-features";
export const UnitFeatures = ({ unit }) => {
    var _a, _b, _c;
    const features = (_a = unit.features) === null || _a === void 0 ? void 0 : _a.preview;
    if (!(features === null || features === void 0 ? void 0 : features.length))
        return null;
    return (_jsx(Box, { marginTop: "spacing.4", display: "flex", flexWrap: "wrap", gap: "spacing.4", testId: testId, children: (_c = (_b = unit.features) === null || _b === void 0 ? void 0 : _b.preview) === null || _c === void 0 ? void 0 : _c.map((feature, i) => (_jsx(Tag, { variant: "subdued", size: "14", testId: `${testId}-item`, children: feature.value }, `unit-feature-${i}`))) }));
};
